module.exports = __webpack_public_path__ + "static/media/wagon-covered.a3c59cd7.svg";